<div class="tab-component">
  <div class="tab-component-wrapper">
    <div class="tab-title">
      <h3>Device Health</h3>
    </div>
    <div class="tab-content">
      <div class="tab-content-wrapper content-wrapper-aggrid">
      <div class="component-ag-grid-wrapper device-health-grid-shell"
        [style.--mc-ag-page-size]="gridLayoutRowCount"
        [style.--mc-ag-host-height.px]="gridHostHeightPx"
        (contextmenu)="preventDefaultContextMenu($event)"
        mcAgGridCopyCellTooltip
        [mcAgGridCopyCellTooltipConfig]="copyCellTooltipConfig"
        style="position: relative;">
        <ag-grid-angular
          class="ag-theme-alpine"
          [rowData]="rowData"
          [rowModelType]="'infinite'"
          [columnDefs]="columnDefs"
          [defaultColDef]="defaultColDef"
          [gridOptions]="gridOptions"
          [domLayout]="'normal'"
          [pagination]="true"
          [paginationPageSize]="paginationPageSize"
          [paginationPageSizeSelector]="pageSizeOptions"
          [cacheBlockSize]="paginationPageSize"
          [datasource]="dataSource"
          (gridReady)="onGridReady($event)"
          (paginationChanged)="onPaginationChanged($event)"
          (cellContextMenu)="onCellContextMenu($event)">
        </ag-grid-angular>

        <div class="custom-context-menu" *ngIf="contextMenu.visible" [ngStyle]="{'top.px': contextMenu.y, 'left.px': contextMenu.x}">
          <ul>
            <li (click)="copyToClipboard(contextMenu.value)">Copy Value</li>
          </ul>
        </div>

      </div>
      </div>
    </div>
  </div>
</div>